// src/App.js

import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './Dashboard';
import Bills from './components/Bills';
import Payments from './components/Payments';
import CreditCards from './components/CreditCards';
import Expenses from './components/Expenses';
import Debts from './components/Debts';
import Income from './components/Income';
import Home from './components/Home';
import Categories from './components/Categories';
import Users from './components/Users';
import Settings from './components/Settings';
import AccountsPage from './components/AccountsPage';
import SmsTest from './components/SmsTest';
import SmsTestSimple from './components/SmsTestSimple';
import VideosPage from './components/VideosPage';

function App() {
  const { isAuthenticated, logout, initialized } = useContext(AuthContext);

  return (
    <Router>
      {!initialized ? (
        <div style={{ padding: 20, textAlign: 'center' }}>Loading…</div>
      ) : (
      <Routes>
        {!isAuthenticated ? (
          <>
            {/* If not authenticated, show login. On successful login, AuthContext updates isAuthenticated */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/sms" element={<SmsTestSimple />} />
            <Route path="/videos" element={<VideosPage />} />
            {/* Any unknown route redirects to /login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <>
            {/* If authenticated, user can access these routes. After login, user is redirected to / (Home) */}
            <Route path="/" element={<Home onLogout={logout} />} />
            <Route path="/dashboard" element={<Dashboard onLogout={logout} />} />
            <Route path="/bills" element={<Bills onLogout={logout} />} />
            <Route path="/payments" element={<Payments onLogout={logout} />} />
            <Route path="/creditcards" element={<CreditCards onLogout={logout} />} />
            <Route path="/expenses" element={<Expenses onLogout={logout} />} />
            <Route path="/debts" element={<Debts onLogout={logout} />} />
            <Route path="/income" element={<Income onLogout={logout} />} />
            <Route path="/categories" element={<Categories onLogout={logout} />} />
            <Route path="/users" element={<Users onLogout={logout} />} />
            <Route path="/settings" element={<Settings onLogout={logout} />} />
            <Route path="/videos" element={<VideosPage onLogout={logout} />} />
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/sms-test" element={<SmsTest onLogout={logout} />} />
            {/* Any unknown route redirects to / (Home) */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
      )}
    </Router>
  );
}

export default App;
